import PropTypes from 'prop-types';
import React from 'react';

import { displayLongDate, transformMessageText } from '../../utils/utils';
import styles from './PriorMessage.module.scss';

const PriorMessage = ({
  content,
  createdTimestamp,
  isReply,
  messageId,
  showPriorMessageLabel = true
}) => (
  <div className={`prior-message ${styles['message-container']}`}>
    {isReply && (
      <span className={styles['message-header']}>
        Sent:{' '}
        <span className={styles['message-date']}>
          {displayLongDate(createdTimestamp)}
        </span>
      </span>
    )}

    {showPriorMessageLabel && (
      <p className={styles['message-header']}>Prior Messages:</p>
    )}
    <div
      className="prior-message-body"
      dangerouslySetInnerHTML={{
        __html: transformMessageText({ content, messageId })
      }}
    />
  </div>
);

PriorMessage.propTypes = {
  content: PropTypes.string,
  createdTimestamp: PropTypes.string,
  isReply: PropTypes.bool,
  messageId: PropTypes.string,
  showPriorMessageLabel: PropTypes.bool
};

export default PriorMessage;
